import script from "./ITabs.vue?vue&type=script&setup=true&lang=js"
export * from "./ITabs.vue?vue&type=script&setup=true&lang=js"

import "./ITabs.vue?vue&type=style&index=0&id=64499ec3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64499ec3"]])

export default __exports__